import React from "react";
import {Link} from "react-router-dom";

export const StyleGuide = () => (
    <div id="styleguide" className="container">
        <div className="row">
            <div className="col-12 col-md-6 desktop">
                <div>
                    <h3>DESKTOP</h3>
                </div>
                <div className="pb-3">
                    <h1>Heading 1</h1>
                </div>
                <div className="pb-3">
                    <h2>Heading 2</h2>
                </div>
                <div className="pb-3">
                    <h3>Heading 3</h3>
                </div>
                <div className="pb-3">
                    <h4>Heading 4</h4>
                </div>
                <div className="pb-3">
                    <h5>Heading 5</h5>
                </div>
                <div>
                    <p>Large paragraph</p>
                </div>
                <div className="pb-3">
                    body
                </div>
                <div className="pb-3">
                    <title className="caption">Caption</title>
                </div>
                <div>
                    <p className="capital">ALL CAPS</p>
                </div>
                <div>
                    <p className="stat">Pull stats</p>
                </div>
                <div className="pb-3">
                    <title className="sub-caption">Sub Caption</title>
                </div>
                <div className="pb-3">
                    <Link to='#'>
                        Text link
                    </Link>
                </div>
            </div>
            <div className="col-12 col-md-6 mobile">
                <div>
                    <h3>MOBILE</h3>
                </div>
                <div className="pb-3">
                    <h1>Heading 1</h1>
                </div>
                <div className="pb-3">
                    <h2>Heading 2</h2>
                </div>
                <div className="pb-3">
                    <h3>Heading 3</h3>
                </div>
                <div className="pb-3">
                    <h4>Heading 4</h4>
                </div>
                <div className="pb-3">
                    <h5>Heading 5</h5>
                </div>
                <div>
                    <p>Large paragraph</p>
                </div>
                <div className="pb-3">
                    body
                </div>
                <div className="pb-3">
                    <title className="caption">Caption</title>
                </div>
                <div>
                    <p className="capital">ALL CAPS</p>
                </div>
                <div>
                    <p className="stat">Pull stats</p>
                </div>
                <div className="pb-3">
                    <title className="sub-caption">Sub Caption</title>
                </div>
                <div className="pb-3">
                    <Link to='#'>
                        Text link
                    </Link>
                </div>
            </div>
        </div>
    </div>
);

